// extracted by mini-css-extract-plugin
export default {"wrapper":"search_filters_bar-module__wrapper--2S8FW","container":"search_filters_bar-module__container--3UwIi","subHeader":"search_filters_bar-module__subHeader--3goWv"};